'use strict';

angular.module('licensure.services')
    .factory('BackgroundChecks', ['$http', '$q', function ($http, $q) {
        return {
            getByUserID: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/BackgroundCheck', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        d.reject(response.data);
                    });

                return d.promise;
            },
           
        }
    }])
;